import axios from "@/api/axios";

const getLessonInfo = (data) => {
    return axios
        .post('/admin/lesson/lesson-info', {lesson: data})
        .then(response => response.data)
}

const getServiceInfo = (data) => {
    return axios
        .post('/admin/lesson/service-info', {service: data})
        .then(response => response.data)
}

const getSpecialistList = (data) => {
    return axios
        .post('/admin/lesson/specialist-list', {specialist: data})
        .then(response => response.data)
}

const getPositionList = (data) => {
    return axios
        .post('/admin/lesson/position-list', {position: data})
        .then(response => response.data)
}

const getRoomList = (data) => {
    return axios
        .post('/admin/lesson/room-list', {room: data})
        .then(response => response.data)
}

const getReasonList = (data) => {
    return axios
        .post('/admin/lesson/reason-list', {reason: data})
        .then(response => response.data)
}

const getCancelReasonList = (data) => {
    return axios
        .post('/admin/lesson/cancel-reason-list', {cancelReason: data})
        .then(response => response.data)
}

const updateLesson = (data) => {
    return axios
        .post('/admin/lesson/update-lesson', {lesson: data})
        .then(response => response.data)
}

const createLesson = (data) => {
    return axios
        .post('/admin/lesson/create-lesson', {lesson: data})
        .then(response => response.data)
}

const cancelLesson = (data) => {
    return axios
        .post('/admin/lesson/cancel-lesson', {lesson: data})
        .then(response => response.data)
}

const getGroupSpecialistList = (data) => {
    return axios
        .post('/admin/lesson/group-specialist-list', {specialistGroup: data})
        .then(response => response.data)
}


export default {
    getLessonInfo,
    getServiceInfo,
    getSpecialistList,
    getPositionList,
    getRoomList,
    getReasonList,
    getCancelReasonList,
    updateLesson,
    createLesson,
    cancelLesson,
    getGroupSpecialistList
}